<template>
  <div class="w1200" style="margin-top: 15px">
    <div class="bg" style="padding-top: 0">
      <div class="hd ys2" style="padding: 20px 0">
        <h3 style="float: left">专题资源</h3>
        <el-button
          type="primary"
          size="small"
          @click="$router.push({ name: 'specialAdd' })"
          style="float: right; margin: 6px 0"
          class="ztan"
          v-if="
            userModule.roles.filter((el) => el.id == 'ThematicResourceManager')
              .length > 0
          "
        >
          <i class="el-icon-plus"></i>
          创建专题</el-button
        >
      </div>

      <div class="bd ys3" style="min-height: 520px">
        <ul v-if="data.length > 0">
          <li
            v-for="(d, i) in data"
            :key="'special' + i"
            @click="jump('/special/details', { id: d.id })"
          >
            <el-image
              :src="uploadUrl + d.typeImage"
              style="height: 150px; width: 100%"
            ></el-image>
            <span>{{ d.typeName }}</span>
          </li>
        </ul>
        <div class="unusual" v-else><span class="pt320">暂无内容</span></div>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        background
        layout="total, prev, pager, next, jumper"
        :total="pages.pageAll"
        :page-size="12"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import link from "../../mixins/link";
export default {
  data() {
    return {
      data: [],
      uploadUrl: "",
      pages: { pageAll: 0, pageSize: 10 },
    };
  },
  mixins: [link],
  computed: {
    ...mapState(["userModule"]),
  },
  props: {
    name1: { type: String },
  },
  mounted() {
    this.uploadUrl = window.sessionStorage.getItem("uploadUrl");
    this.getData(1);
  },
  methods: {
    getData(v = 1, s = 10) {
      this.$ajax
        .post("/server/thematic/type/list", {
          page: v,
          size: 12,
          typeNameLike: this.name1,
        })
        .then((res) => {
          this.data = res.list;
          this.pages.pageAll = res.total;
        });
    },
    handleCurrentChange(v) {
      this.getData(v);
    },
    handleSizeChange(v) {
      this.getData(1, v);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/page/special/list.vue